import NotificationDialog from './NotificationDialog';

export default NotificationDialog;
